module.exports = __webpack_public_path__ + "img/news1.5e21fa70.svg";